import React from 'react';
import { withRouter } from 'react-router';
import { historyShape, userShape } from 'constants/propTypes';
import { useManagedMutation } from 'utils/managedHooks';
import { CREATE_PROVISIONAL } from 'store/mutations';
import BuyThalysPass from './BuyThalysPass';
import { buildThalysPassRequest } from './BuyThalysPass.utils';

const Index = ({ user, history, ...props }) => {
  const [createProvisionalBooking, { loading: createProvisionalBookingLoading, error: createProvisionalBookingError }] =
    useManagedMutation(CREATE_PROVISIONAL);

  const membershipNumber = new URLSearchParams(history.location.search).get('membershipNumber');

  const onSubmit = async (values) => {
    const formattedRequest = buildThalysPassRequest(values, membershipNumber);
    let createProvisional = null;

    try {
      createProvisional = await createProvisionalBooking({
        variables: formattedRequest
      });

      history.push(
        `/booking/${createProvisional?.data?.createBooking?.reference}/review-booking?isSubscription=true&membershipNumber=${membershipNumber}` // eslint-disable-line max-len
      );
    } catch (_) {} // eslint-disable-line no-empty
  };

  return (
    <BuyThalysPass
      {...props}
      history={history}
      user={user}
      onSubmit={onSubmit}
      createProvisionalBookingLoading={createProvisionalBookingLoading}
      createProvisionalBookingError={createProvisionalBookingError}
    />
  );
};

Index.propTypes = {
  user: userShape,
  history: historyShape
};

export default withRouter(Index);
